class RegionalMap {
  /**
   * @type {HTMLElement}
   * @private
   */
  _map;

  /**
   * @type {HTMLElement[]}
   * @private
   */
  _regions = [];

  /**
   * @type {HTMLElement[]}
   * @private
   */
  _regionNames = [];

  /**
   * @type {HTMLElement}
   * @private
   */
  _activeRegionName;

  /**
   * @type {HTMLElement}
   * @private
   */
  _activeRegion;

  /**
   * @type {HTMLElement}
   * @private
   */
  _hoverRegion;

  /**
   * @param {HTMLElement} map
   */
  constructor(map) {
    this._map = map;
    this._regions = Array.from(map.querySelectorAll('g[data-region]'));
    this._regionNames = Array.from(
      document.querySelectorAll(`.map-${this._map.dataset.map} .region-contact`)
    );

    this._regionNames.forEach((regionName) => {
      regionName.addEventListener('click', () =>
        this._onRegionNameClick(regionName)
      );
      regionName.addEventListener('pointerenter', () =>
        this._onRegionNameHover(regionName)
      );
      regionName.addEventListener('pointerleave', () =>
        this._onRegionNameHover(null)
      );
    });
    this._regions.forEach((region) =>
      region.addEventListener('click', () => this._onRegionClick(region))
    );

    this._activeRegionName = this._regionNames[0];
    this._activeRegion = this._getRegionForRegionName(this._activeRegionName);
    this._render();
  }

  _onRegionNameClick(regionName) {
    this._activeRegionName = regionName;
    this._activeRegion = this._getRegionForRegionName(regionName);
    this._render();
  }

  _onRegionNameHover(regionName) {
    this._hoverRegion = regionName
      ? this._getRegionForRegionName(regionName)
      : null;
    this._render();
  }

  _onRegionClick(region) {
    this._activeRegion = region;
    this._activeRegionName = this._getRegionNameForRegion(region);
    this._render();
  }

  _render() {
    this._regionNames.forEach((regionContact) =>
      regionContact.classList.remove('is-active')
    );
    this._regions.forEach((group) =>
      group.classList.remove('is-active', 'hover')
    );

    this._activeRegionName?.classList.add('is-active');
    this._activeRegion?.classList.add('is-active');

    if (this._hoverRegion) {
      this._hoverRegion.classList.add('hover');
    }
  }

  /**
   * @param {HTMLElement} regionName
   * @returns {HTMLElement}
   * @private
   */
  _getRegionForRegionName(regionName) {
    return this._map.querySelector(`g[data-region="${regionName?.id}"]`);
  }

  /**
   * @param {HTMLElement} region
   * @returns {HTMLElement}
   * @private
   */
  _getRegionNameForRegion(region) {
    return this._regionNames.find(
      (regionContact) => regionContact.id === region?.dataset.region
    );
  }
}

export const regionalMap = () => {
  document
    .querySelectorAll('.regional-map')
    .forEach((map) => new RegionalMap(map));
};
